import { ModalWrapper } from 'src/components/ModalWrapper';
import { Button } from 'src/components/Buttons/Button';
import { useTranslation } from 'react-i18next';
import { useModalContext } from 'src/hooks/useModalContext';
import { EventShopModalProps } from './types';
import { EventShopModalContainer } from './components/ShopModalContainer';
import { useBuyItemHandler } from './hooks/useBuyItemHandler';
import { FreespinsPurchaseBlock } from 'src/pages/EventShop/AuthorizedEventShop/components/FreespinsPurchaseBlock';

export const BuyFreespinsEventModal = () => {
  const { modalProps } = useModalContext<EventShopModalProps>();
  const { t } = useTranslation();

  const { handleClick } = useBuyItemHandler();

  return (
    <ModalWrapper showCross={false} isTransparentBg>
      <EventShopModalContainer title="christmasShop.freeSpins" text="christmasShop.doYouWantFs">
        <div className="flex flex-col items-center mb-[50px]">
          <FreespinsPurchaseBlock item={modalProps?.item} />
          <Button className="w-[165px] self-center" onClick={handleClick}>
            {t('christmasShop.accept')}
          </Button>
        </div>
      </EventShopModalContainer>
    </ModalWrapper>
  );
};
